import {FormDataRepository} from '../../domain/shared/repositories/FormDataRepository';
import {AssignmentFormData, DeliveryFormData} from '../../domain/shared/entities/FormData';
import {seliApiClient, ApiError} from '../../shared/http/apiClient';
import {AsyncStorageAdapter} from '../storage/AsyncStorageAdapter';

interface AssignmentFormDataDTO {
  recurrences: Array<{id: number; name: string}>;
  statuses: Array<{id: number; name: string}>;
}

interface DeliveryFormDataDTO {
  statuses: Array<{id: number; name: string}>;
  actions: Array<{id: number; name: string}>;
}

export class FormDataRepositoryImpl implements FormDataRepository {
  private storageAdapter: AsyncStorageAdapter;

  constructor() {
    this.storageAdapter = new AsyncStorageAdapter();
  }

  async getAssignmentFormData(): Promise<AssignmentFormData> {
    try {
      // Get auth token
      const user = await this.storageAdapter.getUser();
      const token = user?.token || null;

      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await seliApiClient.get<AssignmentFormDataDTO>(
        '/api/benefits_managment/assignments/form-data',
        {
          Authorization: `Bearer ${token}`,
        }
      );
      
      return response.data;
    } catch (error: any) {
      const apiError = error as ApiError;
      console.error('Error fetching assignment form data:', apiError);

      if (apiError.status === 401 || apiError.status === 403) {
        throw new Error('No autorizado. Por favor inicia sesión nuevamente.');
      } else {
        throw new Error(
          apiError.message ||
            apiError.data?.message ||
            'Error al obtener los datos del formulario de asignación',
        );
      }
    }
  }

  async getDeliveryFormData(): Promise<DeliveryFormData> {
    try {
      // Get auth token
      const user = await this.storageAdapter.getUser();
      const token = user?.token || null;

      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await seliApiClient.get<DeliveryFormDataDTO>(
        '/api/benefits_managment/deliveries/form-data',
        {
          Authorization: `Bearer ${token}`,
        }
      );
      
      return response.data;
    } catch (error: any) {
      const apiError = error as ApiError;
      console.error('Error fetching delivery form data:', apiError);

      if (apiError.status === 401 || apiError.status === 403) {
        throw new Error('No autorizado. Por favor inicia sesión nuevamente.');
      } else {
        throw new Error(
          apiError.message ||
            apiError.data?.message ||
            'Error al obtener los datos del formulario de beneficio otorgado',
        );
      }
    }
  }
}
